import {PickupLocationResponse} from 'api/dataTypes';
import {PickupPointsGroup} from 'modules/Cart/containers/CartFormPickupPoints/PickupPointsGroup/PickupPointsGroup';
import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './CartFormPickupPoints.module.css';

type Props = {
    onSelect: (point: PickupLocationResponse) => void;
    selectedPoint?: PickupLocationResponse;
    points: PickupLocationResponse[];
};
export const CartFormPickupPoints: FC<Props> = ({
    onSelect,
    selectedPoint,
    points,
}) => {
    return (
        <div className={styles.block}>
            <PickupPointsGroup
                points={points}
                onSelect={onSelect}
                selectedPoint={selectedPoint}
            />

            <Text.Semibold12 className={styles.text}>
                <span className={styles.warn}>Внимание!</span>
                Для осуществления самовывоза со склада, вам необходимо
                предварительно согласовать заказ и время отгрузки с нашими
                менеджерами.
            </Text.Semibold12>
        </div>
    );
};
